export default __webpack_public_path__ + "static/media/profile.72a053df.jpg";